import React from 'react'
import PriceCard from './PriceCard';
import { Button, Card, Checkbox, Col, Divider, Row } from 'antd';
import { InfoCircleOutlined } from "@ant-design/icons";
import CommonCard, { colCardStyle, contentAreaStyle, outerCardStyle } from './CommonCard';



function AddOns({  sessionData, packageData, selectedPackages, setSelectedPackages, selectedSessions, setSelectedSessions, addOnData, selectedAddOns, setSelectedAddOns, ...props}) {



     const toggleSelect = (packageItem) => {
    setSelectedAddOns((prev) => {
      const exists = prev.find((s) => s.uuid === packageItem.uuid);
      if (exists) {
        return prev.filter((s) => s.uuid !== packageItem.uuid);
      }
      return [...prev, packageItem];
    });

  };

  return (
      <div style={outerCardStyle}>
      <div style={contentAreaStyle}>
            <Row gutter={[16, 16]}>
      {addOnData?.map((packageItem) => {
        const isSelected = selectedAddOns?.some((s) => s.uuid === packageItem.uuid);
        return (
          <Col xs={24} sm={24} md={24} lg={6} xl={6} key={packageItem.uuid} style={colCardStyle}>
             <CommonCard
              data={packageItem}
              isSelected={isSelected}
              toggleSelect={toggleSelect}
              modelName="AddOn"
            >
            </CommonCard>
          </Col>
        );
      })}
    </Row>
        </div>
              <div style={{ textAlign: 'left', alignSelf: 'flex-start', marginTop: 3 }}>
            <PriceCard  packages={selectedPackages} sessions={selectedSessions} addons={selectedAddOns} />
        </div>
    </div>
  )
}

export default AddOns